// ESM-Konvertierung von lib/scripts/CLS_CLanguage.js (Phase 4, Welle 1b).
// i18n-Lookup: liest lib/language/<sprache>/<TYP>.txt (pipe-separierte
// KEY|Text-Zeilen) einmalig pro Typ und cached die Map.
export class CLanguage {
  constructor(language) {
    this.language = language;
    this.langfiles = {};
  }

  getText(type, name) {
    type = type.toUpperCase();

    if (!this.langfiles[type]) {
      const file = "lib/language/" + this.language + "/" + type + ".txt";
      const lines = fs.readFileSync(file).toString().split("\n");
      this.langfiles[type] = {};
      for (let i = 0; i < lines.length; i++) {
        const arr = lines[i].toString().split("|");
        this.langfiles[type][arr[0]] = arr[1];
      }
    }

    return this.langfiles[type][name] ? this.langfiles[type][name] : "n/a";
  }
}
